import Vue from 'vue'
import Router from 'vue-router'
import Security from '@/plugins/security'

import userRoutes from '@/router/user'
import organizationRoutes from '@/router/organization'
import vesselRoutes from '@/router/vessel'
import roleinvesselRoutes from '@/router/roleinvessel'
import roleinorganizationlRoutes from '@/router/roleinorganization'

import PageNotFound from '@/components/error/PageNotFound'
import GenericError from '@/components/error/GenericError'
import Forbidden from '@/components/error/Forbidden'

import AuthCallback from '@/views/AuthCallback'
import CheckTotalCredit from '@/views/CheckTotalCredit.vue'
import Map from '@/views/Map'
import Home from '@/views/Home'

Vue.use(Router)
Vue.use(Security)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...userRoutes,
    ...organizationRoutes,
    ...vesselRoutes,
    ...roleinvesselRoutes,
    ...roleinorganizationlRoutes,
    {
      name: 'home',
      path: '/',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (window.location.hostname.includes('hotspot')) {
          next()
          return
        }
        if ('home' === to.name) {
          const userOrganizations = Vue.security.getUserOrganizations()
          const userVessels = Vue.security.getUserVessels()
          if (userOrganizations.length > 1) {
            next({ name: 'OrganizationListMap' })
          } else if (Vue.security.isGranted(userOrganizations[0], 'ROLE_SHIPOWNER') || userVessels.length > 1) {
            next({
              name: 'OrganizationShowMap',
              params: { id: Vue.iriToId(userOrganizations[0]['@id']) }
            })
          } else if (userVessels) {
            next({
              name: 'VesselShowMap',
              params: { id: Vue.iriToId(userVessels[0]['@id']) }
            })
          } else {
            next()
          }
        }
      }
    },
    { name: 'organizations-list', path: '/organizations-list', component: Map },
    {
      name: 'logout',
      path: '/logout',
      beforeEnter: () => {
        localStorage.removeItem('user')
        Vue.keycloak.logout()
      }
    },
    { name: 'authCallback', path: '/auth-callback', component: AuthCallback },
    { name: 'totalCredit', path: '/total-credit', component: CheckTotalCredit },

    {
      name: 'pageNotFound',
      path: '*',
      component: PageNotFound
    },
    {
      name: 'genericError',
      path: '*',
      component: GenericError
    },
    {
      name: 'forbiddenError',
      path: '*',
      component: Forbidden
    }
  ]
})

const notAuthRoutes = [
  'totalCredit',
  'logout',
  'authCallback',
  'pageNotFound',
  'genericError',
  'forbiddenError',
  'start'
]

router.beforeEach((to, from, next) => {
  if (
    notAuthRoutes.includes(to.path) ||
    notAuthRoutes.includes(to.name) ||
    window.location.hostname.includes('hotspot')
  ) {
    next()
    return
  }

  if (
    !Vue.security.getUser() ||
    !Vue.keycloak.authenticated ||
    Vue.keycloak.tokenParsed.sub !== Vue.security.getUser().sub
  ) {
    Vue.keycloak.login({
      redirectUri: window.origin + '/auth-callback'
    })
  }

  if (Vue.security.isAllowed()) {
    next()
  } else {
    next({ name: 'forbiddenError', params: [to.path], replace: true })
  }
})

export function isNoAuthRoute() {
  return notAuthRoutes.includes(router.currentRoute.path) || notAuthRoutes.includes(router.currentRoute.name)
}

export default router
